@if (message) {
  <p [class.biggerFont]="isBiggerFont">{{ message }}</p>
}
<spinner
  [attr.e2e-attr]="E2E_ATTRIBUTES.LOADER_COMPONENT"
  [class.size-md]="!isDefaultSize"
></spinner>
